import {
  Avatar,
  Button,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React from 'react';
import DialogHeader from '../DialogHeader';

const useStyles = makeStyles((theme) => ({
  list: {
    width: '40vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      width: '80vw',
    },
  },
}));

const ViewAssociatedCDMOTeamMembers = (props) => {
  const { associatedCDMOTeamMember, handleClose } = props;
  const classes = useStyles();

  //console.log(props);
  return (
    <div className={classes.list}>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        style={{ padding: '1rem' }}
      >
        <Grid item xs={12}>
          <DialogHeader header={'Associated CDMO team members'} />
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              style={{
                whiteSpace: 'nowrap',
                fontSize: '1.5rem',
                fontWeight: '500',
                paddingBottom: '10px',
                justifySelf: 'flex-start',
              }}
            >
              {associatedCDMOTeamMember.organizationName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List>
              {associatedCDMOTeamMember.teamMembers.map((user) => (
                <ListItem key={user.saasUserId} alignItems='center'>
                  <ListItemAvatar style={{ margin: 0 }}>
                    <Avatar>{user.name.charAt(0)}</Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography
                        variant='subtitle1'
                        style={{ fontWeight: 500 }}
                      >
                        {user.name}
                      </Typography>
                    }
                    secondary={<>{`${user.department} - ${user.roleName}`}</>}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        item
        xs={12}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '1rem',
          alignContent: 'flex-end',
        }}
      >
        <Button
          variant='contained'
          color='secondary'
          style={{ textTransform: 'none' }}
          onClick={() => handleClose()}
        >
          Close
        </Button>
      </Grid>
    </div>
  );
};

export default ViewAssociatedCDMOTeamMembers;
